<template>
    <div>
        <header class="mui-bar mui-bar-nav">
			<a class="mui-icon mui-icon-left-nav mui-pull-left" @click="$router.push({path: '/home'});"></a>
			<h1 class="mui-title">明细</h1>
			<button class="mui-btn mui-btn-link mui-pull-right"><a @click="filter()">筛选</a></button>
		</header> 
		<div class="mui-content">
			<ul class="mui-table-view" v-if="sites.length>0">
			    <li class="mui-table-view-cell mui-media"  v-for="(site,index) in sites" :key="index">
			        <a href="javascript:;">
			            <div class="mui-media-body mui-pull-left">
			               	{{site.operation}}{{site.energy_type_name}}
			                <p class='mui-ellipsis'>{{site.record_time}}</p>
			            </div>
			            <div class="mui-media-body mui-pull-right mui-text-right">
			            	<!-- {{site.price}} -->
			                <p class='mui-ellipsis'>{{site.amount}}元</p>
			            </div>
			        </a>
			    </li>
			</ul>
			<div class="norecord" v-else>
				<img src="../assets/imgs/noInfo.png" class="noInfo"/>
				<p>暂无数据</p>
			</div>
		</div>	
    </div>
</template>
<script>
	import { Detail } from '@/request/api';
    export default{
    	data: function(){
			return {
				sites: []
			}
		},
		created(){
			this.getMoreInfo();
		},
    	methods:{
			filter(){
				this.$router.push({path: '/filter'});
			},
			getMoreInfo(){
				//获取近半年的信息。
				//获取今天时间 以及半年前的日期
				var facade = JSON.parse(sessionStorage.getItem("facade"));
				var tenant_id = sessionStorage.getItem("tenant_id");
				var filterInfo = JSON.parse(sessionStorage.getItem("filterInfo"));
				var operations = '';
				if(filterInfo && filterInfo.operation){
					if(filterInfo.operation == '0'){
						operations = '开户'
					}else if(filterInfo.operation == '1'){
						operations = '充值'
					}else if(filterInfo.operation == '2'){
						operations = '退户'
					}else if(filterInfo.operation == '3'){
						operations = '扣费'
					}
				}
				Detail({     
			    	"energy_type_id":filterInfo?filterInfo.energy.energyid:'',
			    	"facade_id":facade.id,
			    	'tenant_id':tenant_id,
			    	'starttime':filterInfo?filterInfo.startTime:'',
			    	'endtime':filterInfo?filterInfo.endTime:'',
			    	'operation':operations||'扣费'
			   	}).then(res => {
			    	// 获取数据成功后的其他操作
			    	if(res.result =='true'){
			    		this.sites = res.data;
			    	}
			    	else{
			    		mui.toast(res.description,{ duration:'long'});	
			    	}
		  		}) 
			}
		}
    }
    
</script>
<style>
     @import '../common/css/public.css';
</style>


// WEBPACK FOOTER //
// src/pages/more.vue